// This component displays all the data for a given menu menuItem.

import { Allergen } from "@dining/api-client";
import { Image, IStackTokens, Stack, Text } from "@fluentui/react";
import classNames from "classnames";
import React from "react";
import { allergenDataToString, getPriceString } from "../../common/dataConversions";
import menuItemPlaceholder from "../../images/menuItemPlaceholder.png";
import styles from "../../styles/menuPreview.module.css";
import { PreviewMenuItem } from "./types/menuPreviewTypes";

export interface MenuItemCardProps {
  menuItem: PreviewMenuItem;
  onSelect: () => void;
  selected: boolean;
  stationId: string;
  cafeId: string;
}

const menuItemCardStackTokens: IStackTokens = { childrenGap: 10 };

const MenuItemCard = ({ menuItem, onSelect, selected, stationId, cafeId }: MenuItemCardProps) => {
  const itemData = menuItem.itemData;
  let allergens: Allergen[] = [];
  let optionalAllergens: Allergen[] = [];
  //Saving image data
  let imageSrc;
  let imageAltText: string;
  if (itemData?.imageUrl) {
    imageSrc = itemData.imageUrl;
    imageAltText = "Image of" + itemData.name + " " + itemData.description;
  } else {
    imageSrc = menuItemPlaceholder;
    imageAltText = "";
  }

  itemData?.allergens?.forEach((allergen) => {
    allergen.optional ? optionalAllergens.push(allergen) : allergens.push(allergen);
  });
  const allergenString = allergenDataToString(allergens);
  const optionalAllergenString = allergenDataToString(optionalAllergens);

  return (
    <Stack horizontal={true} verticalAlign={"center"} tokens={menuItemCardStackTokens} className={styles.menuItemCard}>
      <Stack.Item>
        <Image height={90} width={90} shouldStartVisible={true} src={imageSrc} alt={imageAltText} />
      </Stack.Item>
      <Stack grow={false}>
        <div className={classNames("ms-fontWeight-bold", styles.menuItemHeader)}>
          {itemData?.name}
          {itemData?.calories && itemData?.calories > -1 ? (
            <span className={styles.calories}> ({itemData?.calories} cal.)</span>
          ) : null}
          {!menuItem.isPublished && <span> *</span>}
        </div>
        <Stack.Item>
          {itemData?.description && <div>{itemData.description}</div>}
          <div className={styles.allergen}>
            {allergenString !== "" && <span>Contains: {allergenString}.</span>}
            {optionalAllergenString !== "" && <span> Optional ingredients: {optionalAllergenString}.</span>}
          </div>
        </Stack.Item>
        <Text className={styles.price}>{getPriceString(itemData?.pricing)}</Text>
      </Stack>
    </Stack>
  );
};

export default MenuItemCard;
